import i18next from 'i18next';
import { Base64 } from 'js-base64';
import _, { get, isFunction, isString } from 'lodash';
import moment from "moment-timezone";
import {EVENT} from '../common/events/listEvents';
import StorageHelper from '../common/StorageHelper';
import { } from '../common/Extensions';
import { BetTypeGroup, BROWSER_KEY, DATA_NOCACHE_STATUS, LOCAL_STORAGE_KEY, LoginStatus, Market, MarketFilter, MOBILE_VIEWS, PrefsMap, VIP_TIER } from "../common/Foundation";
import SameSite from '../common/SameSite';
import Utils from "../common/Utils";
import AlertComponentAction from '../components/BaseComponent/AlertComponent/AlertComponentAction';
import memberServices from "../services/MemberService";
import $ from 'jquery';
import Constants from '../common/Constants'
import { KYC_VERIFIED } from '../components/MainComponent/AsiaView/MbAsiaVIPSignup/utils';
import { handleInjectScript, isNeededInjectScript  } from '../common/Hooks/useScriptInjector/helper';
import { ADMILL_NOSCRIPT_ID_LOGIN, ADMILL_SCRIPT_ID_LOGIN } from '../common/Hooks/useScriptInjector/constant';


export default class AccountAction {
    static LOGIN_SUCCESS = [LoginStatus.SUCCESS_WITH_STT_1, LoginStatus.SUCCESS_WITH_STT_3, LoginStatus.SUCCESS_WITH_STT_6]
    static fireEventReloadAccountBalance() {
        window.fireEvent(EVENT.ACCOUNT_BALANCE_RELOAD);
    }

    static async getQuickStakeData(AccountStore) {
        try {
            const response = await memberServices.getQuickStakeInfor();
            if(response.data) {
                const stakeDefault = !!response.data.stakeDefault
                    ? response.data.stakeDefault.split(":").map((stake) => Number(stake))
                    : [0, 0, 0, 0]
                const stakeValue = !!response.data.stakeValue
                    ? response.data.stakeValue.split(",").map((stake) => Number(stake))
                    : stakeDefault
                const quickStakeData = {
                    ...response.data,
                    stakeDefault,
                    stakeValue
                };
                AccountStore.setQuickStakeData(quickStakeData)
            }
        }
        catch (err) {
            console.log(err)
        }
    }

    static handleInjectAdmillScript({uid}){
        const isAllowInject = Boolean(Utils.isPA() && window.env.enableAdmillTags)
        if(!uid || !isAllowInject || !isNeededInjectScript(ADMILL_SCRIPT_ID_LOGIN)) return

        const textContent = ` window._adftrack = Array.isArray(window._adftrack) ? window._adftrack : (window._adftrack ? [window._adftrack] : []);
        window._adftrack.push({
        HttpHost: 'track.adform.net',
        pm: 2868465,
        divider: encodeURIComponent('|'),
        pagename: encodeURIComponent('Pinnacle_Login'),
        order : { 
             orderid: '${uid}'
        }       
        });
        (function () { var s = document.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://s2.adform.net/banners/scripts/st/trackpoint-async.js'; var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x); })();`
        handleInjectScript({
          props: {
            id: ADMILL_SCRIPT_ID_LOGIN,
            textContent,
            type: 'text/javascript'
          },
          comment: {
            start: `<!-- Adform Tracking Code BEGIN -->`,
            end: `<!-- Adform Tracking Code END -->`
          }
        }) 
    }

    static handleInjectAdmillNoscript(){
        const isInjectAdmillTags = Boolean(Utils.isPA() && window.env.enableAdmillTags)
        if(!isInjectAdmillTags || !isNeededInjectScript(ADMILL_NOSCRIPT_ID_LOGIN)) return

        handleInjectScript({
            targetToInject: 'noscript',
            elementToInject: 'body',
            props: {
              id: ADMILL_NOSCRIPT_ID_LOGIN,
              textContent: ` <p style="margin:0;padding:0;border:0;">
                               <img src="https://track.adform.net/Serving/TrackPoint/?pm=2868465&ADFPageName=Pinnacle_Login&ADFdivider=|" width="1" height="1" alt="" />
                              </p>
                           `,
            },
            comment: {
              start: `<!-- Adform Tracking Code BEGIN -->`,
              end: `<!-- Adform Tracking Code END -->`
            }
          }) 
    }

    static async signin(loginInfo) {
        const {
            loginId,
            password,
            captcha,
            captchaToken,
            trustClientHeader,
            otp
        } = loginInfo;
        try {
          // If header-based authentication is enabled, use the authenticate method.
          if (StorageHelper.isHeaderBasedEnable()) {
            const response = await memberServices.authenticate(
              loginId,
              password,
              captcha,
              captchaToken,
              trustClientHeader,
              otp
            );
            this.handleInjectAdmillScript({
                uid: response.headers['x-uid']
            });
            this.handleInjectAdmillNoscript()
            return this.convertToResultAuthenticate({ ...response, loginId: loginId })
          }

          // Otherwise, use the postLoginAPI method.
          const response = await memberServices.postLoginAPI(
            loginId,
            password,
            captcha,
            captchaToken,
            trustClientHeader
          );
            this.handleInjectAdmillScript({
                uid: response.headers['x-uid']
            });
            this.handleInjectAdmillNoscript()
            return this.convertToResultLogin({ ...response, loginId: loginId })
        } catch (e) {
            console.log("ERROR LOGIN: ", e);
            return {
                auth: false,
                options: null,
                message: i18next.t('errors:ERROR_SERVICE', { 0: 'login' })
            };
        }
    }


    static convertToResultAuthenticate(response) {
        const resultLogin = {
            auth: false,
            options: null,
            message: '',
            status: LoginStatus.INVALID_USER_OR_PASS
        };
        const xAppData = _.get(response, `headers[${LOCAL_STORAGE_KEY.APP_DATA}]`, '');
        StorageHelper.saveXAppData(xAppData, true);
        if (!_.isNil(response.data)) {
            //Response is a plain object
            if (_.isPlainObject(response.data)) {
                const { code, failedAttempts, tokens } = response.data;
                // Login successfully
                if (this.isChangePasswordPage()) {
                    this.updateTokenStorage(tokens)
                } else {
                    StorageHelper.saveToken(JSON.stringify(tokens));
                }

                switch (code) {
                    case LoginStatus.SUCCESS_WITH_STT_1:
                    case LoginStatus.SUCCESS_WITH_STT_6:
                        // Login success after number failed count
                        if (failedAttempts) {
                            return this.handleLoginSuccessAfterFailed(resultLogin, failedAttempts);
                        }
                        return this.handleLoginSuccess(resultLogin, code);
                    case LoginStatus.SUCCESS_WITH_STT_2:
                    case LoginStatus.NO_SECURITY_QA:
                        return this.handleLoginRquiredChangePassword(resultLogin, response.loginId);
                    case LoginStatus.SUCCESS_WITH_STT_3:
                        return this.handleLoginShowTermCondition(resultLogin);
                    default:
                        return this.handleLoginTemporaryFailed(resultLogin, response.data);
                }
            }
            //Response is a plain number
            return this.handleLoginFailed(resultLogin, response.data);
        }
        return resultLogin;
    }

    static handleLoginSuccess(resultLogin, code) {
        resultLogin.message = i18next.t('errors:SUCCESS_LOGIN');
        resultLogin.status = code;
        resultLogin.auth = true;
        return resultLogin;
    }

    static handleLoginFailed(resultLogin, code) {
        switch (code) {
            case LoginStatus.EMPTY_CAPTCHA:
                resultLogin.message = i18next.t('errors:EMPTY_CAPTCHA');
                resultLogin.status = code;
                return resultLogin;
            case LoginStatus.INVALID_CAPTCHA:
                resultLogin.message = i18next.t('errors:INVALID_CAPTCHA');
                resultLogin.status = code;
                return resultLogin;
            case LoginStatus.INVALID_TRUSTCODE:
            case LoginStatus.INVALID_USER_OR_PASS:
                resultLogin.message = i18next.t('errors:INVALID_LOGINID_PASSWORD');
                resultLogin.status = code;
                return resultLogin;
            case LoginStatus.BLOCKED_IP_RING_FENCING:
                resultLogin.status = code;
                return resultLogin;
            case LoginStatus.LOGIN_FAILED:
                resultLogin.message = i18next.t('errors:ERROR_LOGIN_FAILED');
                resultLogin.status = code;
                return resultLogin;
            case LoginStatus.WRONG_COUNTRY:
                resultLogin.message = i18next.t('errors:INVALID_CURRENT_IP');
                resultLogin.status = code;
                return resultLogin;
            case LoginStatus.ACCOUNT_UNVERIFIED:
                resultLogin.message = i18next.t('errors:ERROR_VERIFIED_ACCOUNT');
                resultLogin.status = code;
                return resultLogin;
            case LoginStatus.WRONG_ODDS_FORMAT:
                resultLogin.message = i18next.t('errors:INVALID_ODD_FORMAT');
                resultLogin.status = code;
                return resultLogin;
            case LoginStatus.INVALID_OTP:
            case LoginStatus.OTP_REQUIRED:
                resultLogin.status = code;
                return resultLogin;
            default:
                return resultLogin;
        }
    }

    static async actionAfterLoginResult(resultLogin, gotoDefaultPage, asiaMobileURL) {
        // Check if header-based authentication is enabled, using the data.nocache V2 API
        if (StorageHelper.isHeaderBasedEnable()) {
            const res = await memberServices.getDataNoCacheAPIV2();
            if (!res || !res.data) return;
            AccountAction.updateTokenStorage(_.get(res, "data.tokens", ""));
            return this.onGetDataNocacheV2(
                res,
                this.onCallDataNoCacheSuccessfully.bind(
                    this,
                    resultLogin,
                    _.get(res, "data.userData", {}),
                    gotoDefaultPage,
                    asiaMobileURL
                )
            );
        }

        // Otherwise, using default data.nocache
        const res = await memberServices.getDataNoCacheAPI();
        this.onCallDataNoCacheSuccessfully(
            resultLogin,
            AccountAction.splitDataNoCache(res.data),
            gotoDefaultPage,
            asiaMobileURL
        );
    }

    static handleNewTokenDataNocache(tokens) {
        AccountAction.updateTokenStorage(tokens);
        window.location.reload();
    }

    static updateTokenStorage = (token) => {
        if (_.isEmpty(token)) return;
        const currentToken = Utils.convertStringToJSON(StorageHelper.getBrowsersStorage(LOCAL_STORAGE_KEY.TOKEN));
        const newToken = { ...currentToken, ...token };
        StorageHelper.saveToken(JSON.stringify(newToken));
    };

    static onCallDataNoCacheSuccessfully(resultLogin, __udata, gotoDefaultPage, asiaMobileURL) {
        if (resultLogin != null) {
            if (resultLogin.auth) {
                this.setInfoAfterLogin();
                // Initialize closeAnnTime value when users logged
                StorageHelper.saveBrowsersStorage(BROWSER_KEY.CLOSE_ANN_TIME, 0, { domain: window.location.hostname });
                const loginId = __udata ? __udata.loginId : "";
                const callbackOptions = {
                    isShowPopUp: false,
                    defaultMobileView: __udata.defaultMobileView,
                    locale: __udata.locale
                };

                this.initSessionCookies(resultLogin.status, loginId);
                if (resultLogin.status == LoginStatus.SUCCESS_WITH_STT_2 || resultLogin.status == LoginStatus.NO_SECURITY_QA) {
                    localStorage.setItem('_needToChangePW', true);
                    //change password go to Asia Page
                    setTimeout(this.gotoAsiaChangePassPage, 800, asiaMobileURL);
                    return;
                } else if (resultLogin.status == LoginStatus.SUCCESS_AFTER_MULTI_FAIL) {
                    if (resultLogin.statusMultiFail === LoginStatus.SUCCESS_WITH_STT_2) {
                        localStorage.setItem('_needToChangePW', true);
                        AlertComponentAction.openAlert(resultLogin.message, '', false, () => this.gotoAsiaChangePassPage());
                        return;
                    } else {
                        AlertComponentAction.openAlertCallBack(resultLogin.message, () => { gotoDefaultPage(callbackOptions); });
                    }
                } else if (resultLogin.status == LoginStatus.SUCCESS_WITH_STT_3) {
                    this.clearCookieAcceptTC(true);
                    setTimeout(gotoDefaultPage, 800, callbackOptions);
                    // window.fireEvent(EVENT.FIRST_LOGIN);

                } else {
                    setTimeout(gotoDefaultPage, 800, callbackOptions);
                    window.fireEvent(EVENT.REFRESH_DATA);
                }
                window.fireEvent(EVENT.GET_DATA_NOCACHE);
            } else {
                AlertComponentAction.openAlert(resultLogin.message);
            }
        }
    }

    static initSessionCookies = (loginStatus, loginId) => {
        const sessionString = `{%22userName%22:%22${loginId}%22%2C%22id%22:%22${loginId}%22%2C%22role%22:{%22bitMask%22:2%2C%22title%22:%22user%22}}`;
        if (loginStatus) {
            StorageHelper.saveBrowsersStorage(BROWSER_KEY.RS, loginStatus);
        }
        StorageHelper.saveBrowsersStorage(BROWSER_KEY._LOGIN_ID, loginId ? Base64.encode(loginId) : "");
        StorageHelper.saveBrowsersStorage(BROWSER_KEY.SESSION, sessionString);
    }

    static gotoAsiaChangePassPage(){
        const path = '/m/' + Utils.getCurrentLang() + '/asian/change-password'
        const rtBack = '?toLogin&rtback=' + encodeURIComponent('/m/' + Utils.getUserLanguage())
        let hrefURL = MOBILE_VIEWS.ASIA === Utils.getViewByURLPath() ? path : `${path}${rtBack}`;
        window.location.href = hrefURL
    }

    static gotoBlockPage(){
        const blockPageUrl = `/${Utils.getCurrentLang()}/block-page`;
        window.location.href = blockPageUrl;
    }

    static clearCookieAcceptTC(saveCookie = true) {
        StorageHelper.removeBrowsersStorage(BROWSER_KEY.IS_SHOW_ACCEPT_TC);
        StorageHelper.removeBrowsersStorage(BROWSER_KEY.IS_SHOW_ACCEPT_TC, {domain: window.location.hostname});
        if(saveCookie) {
            StorageHelper.saveBrowsersStorage(BROWSER_KEY.IS_SHOW_ACCEPT_TC, true);
        }
        // For Mobile OLD version
        Utils.setShowTCPageST(saveCookie);
    }

    static convertToResultLogin(response) {
        const resultLogin = {
            auth: false,
            options: null,
            message: '',
            status: LoginStatus.INVALID_USER_OR_PASS
        };
        // Login success
        if (response.data == LoginStatus.SUCCESS_WITH_STT_1 || response.data == LoginStatus.SUCCESS_WITH_STT_6) {
            return this.handleLoginSuccess(resultLogin, response.data);
        }

        if (response.data == LoginStatus.SUCCESS_WITH_STT_2 || response.data == LoginStatus.NO_SECURITY_QA) {
            return this.handleLoginRquiredChangePassword(resultLogin, response.loginId);
        }

        if (response.data == LoginStatus.SUCCESS_WITH_STT_3) {
            return this.handleLoginShowTermCondition(resultLogin);
        }

        if (_.isPlainObject(response.data)) {
            return this.handleLoginTemporaryFailed(resultLogin, response.data);
        }

        if (isString(response.data) && response.data.split('\n').length > 1) {
            return this.handleLoginSuccessAfterFailed(resultLogin, response.data);
        }

        return this.handleLoginFailed(resultLogin, response.data);
    }

    static handleLoginSuccessAfterFailed(resultLogin, failedAttempts) {
        const result = failedAttempts.split("\n");
        if (!_.isNil(result[3])) {
            const dateTime = moment(new window.DateTZ(window.parseInt(result[2]))).format('ddd, MMM DD YYYY HH:mm [GMT]Z');
            const msg = i18next.t('errors:SUCCESS_LOGIN_AFTER_FAILED', {
                0: result[0],
                1: result[1],
                2: dateTime
            });
            resultLogin.message = msg;
            resultLogin.status = LoginStatus.SUCCESS_AFTER_MULTI_FAIL;
            resultLogin.auth = true;
            resultLogin.statusMultiFail = parseInt(result[3]);
            return resultLogin;
        }
    }

    static handleLoginTemporaryFailed(resultLogin, response) {
        const { code, error, userType, url, expire } = response;

        // self exclusion account
        if (error === LoginStatus.SELF_EXCLUSION) {
            if (moment(expire).diff(moment(), 'days') > 90) {
                resultLogin.message = i18next.t('errors:SELF_EXCLUSION');
            } else {
                const dateTime = moment(expire).format('ddd, MMM DD YYYY HH:mm A');
                resultLogin.message = i18next.t('errors:M004', { 0: dateTime });
            }
            return resultLogin;
        }

        // suspended account
        if (code == LoginStatus.ACCOUNT_SUSPENDED) {
            resultLogin.status = LoginStatus.ACCOUNT_SUSPENDED;
            resultLogin.message = userType == 'cash' ?
                i18next.t('errors:ERROR_LOGIN_MUCH_TIME_CASH') :
                i18next.t('errors:ERROR_LOGIN_MUCH_TIME_CREDIT');
            return resultLogin;
        }

        if (code == LoginStatus.TRY_IN_FEW_MINS) {
            resultLogin.message = userType.toLowerCase() === 'cash'
                ? i18next.t('errors:ERROR_LIMIT_LOGIN_FAILED_FEW_MIN_CASH')
                : i18next.t('errors:ERROR_LIMIT_LOGIN_FAILED_FEW_MIN_CREDIT');
            return resultLogin;
        }

        if (code == LoginStatus.TRY_IN_20_MINS) {
            resultLogin.message = userType.toLowerCase() == 'cash'
                ? i18next.t('errors:ERROR_LIMIT_LOGIN_FAILED_20_MIN_CASH')
                : i18next.t('errors:ERROR_LIMIT_LOGIN_FAILED_20_MIN_CREDIT');
            return resultLogin;
        }

        if (code == LoginStatus.EXCEED_FAILED_LOGIN_TIME_LIMIT) {
            resultLogin.message = i18next.t(
                "errors:EXCEED_FAILED_LOGIN_TIME_LIMIT"
            );
            return resultLogin;
        }

        if (code == LoginStatus.ACCOUNT_MIGRATED_TO_PS3838) {
            resultLogin.message = i18next.t('errors:ERROR_ACCOUNT_MIGRATION', { 0: url, 1: url });
            resultLogin.status = code;
            localStorage.setItem("urlMigration", url);
            return resultLogin;
        }
    }
    
    static handleLoginRquiredChangePassword(resultLogin, loginId) {
        resultLogin.message = i18next.t('errors:HAVE_TO_CHANGEPASSWORD');
        resultLogin.status = LoginStatus.SUCCESS_WITH_STT_2;
        resultLogin.auth = true;
        resultLogin.loginId = loginId;
        return resultLogin;
    }

    static handleLoginShowTermCondition(resultLogin) {
        resultLogin.message = i18next.t('errors:SHOW_TERM_CODITION');
        resultLogin.status = LoginStatus.SUCCESS_WITH_STT_3;
        resultLogin.auth = true;
        return resultLogin;
    }


    static async logout(callback) {
      try {
        AccountAction.clearSession(); 
        const res = await memberServices.postLogoutAPI();
        if(res && res.data) {
            if (callback) {
                callback()
                return
            }
            this.cleanUp();
        }
        return res
      } catch (err) {
        this.cleanUp();
        return
      }
    }

    static async checkLogout() { // Check case update URL + Enter without change password
        if(!this.isAuth()) return
        const needToChangePW = localStorage.getItem('_needToChangePW')
		if (needToChangePW && !this.isChangePasswordPage()) {
			return await this.logout()
		}
        return
    }

    static cleanUp() {
      this.clearDataOnBrowser();
      AccountAction.clearCookieAcceptTC(false);
      this.redirect()
    }

    static getArcadiaURL (domain, pathname){
      const returnURL = encodeURIComponent(`${window.location.origin}${pathname}`);
      return `${domain.replace("/{locale}", "")}/${Utils.getCurrentLang()}/?isLogout=true&returnUrl=${returnURL}`
    }
    
    static checkGDPRForm(layoutTemplateStore) {
      const templateData = layoutTemplateStore.templateData;
      const currentViewContainer = layoutTemplateStore.currentViewContainer;
      const footerContainer = _.get(templateData, 'footerContainer', {});
      if (footerContainer[currentViewContainer]) {
        return footerContainer[currentViewContainer].filter(f => f.componentName === "MbGDPRModalComponent").length > 0;
      } else if (footerContainer['formal']) {
        return footerContainer['formal'].filter(f => f.componentName === "MbGDPRModalComponent").length > 0;
      }
      return false;
    }

    static async getDataNoCache(templateName, layoutTemplateStore) {
        // If header-based caching is enabled, use the new API endpoint.
        if (StorageHelper.isHeaderBasedEnable()) {
            const res = await memberServices.getDataNoCacheAPIV2();
            if (!res || !res.data) return {};

            return this.onGetDataNocacheV2(
                res,
                this.convertUserFromNoCache.bind(
                    this,
                    res,
                    _.get(res, "data.userData", {}),
                    templateName, layoutTemplateStore
                )
            );
        }

        // Otherwise, use the legacy API endpoint.
        const res = await memberServices.getDataNoCacheAPI();
        if (!res.data.includes("__udata")) {
            const script = `<script type="text/javascript">${res.data}</script>`;
            const range = document.createRange();
            document.body.appendChild(range.createContextualFragment(script));
            return;
        }
        return this.convertUserFromNoCache(
            res,
            AccountAction.splitDataNoCache(res.data),
            templateName,
            layoutTemplateStore
        );
    }

    static onGetDataNocacheV2(res, callback) {
        const { status, tokens } = res.data;
        switch (status) {
            case DATA_NOCACHE_STATUS.NEW_TOKEN:
                AccountAction.handleNewTokenDataNocache(tokens);
                return;
            case DATA_NOCACHE_STATUS.LOGOUT:
                AccountAction.logout();
                return;
            case DATA_NOCACHE_STATUS.UNAUTHENTICATED:
                const token = StorageHelper.getBrowsersStorage(LOCAL_STORAGE_KEY.TOKEN);
                token && localStorage.setItem(LOCAL_STORAGE_KEY.SESSION_EXPIRED, true);
                StorageHelper.removeToken();
                StorageHelper.removeKeysInXAppData();
                return isFunction(callback) ? callback() : {};
            default:
                return isFunction(callback) ? callback() : {};
        }
    }

    static convertUserFromNoCache(res, __udata, templateName, layoutTemplateStore) {
        let user = {};
        window.wagerMode = __udata.wagerMode;
        __udata.userIp = Utils.getRealIP(__udata, res);

        // white label and pa will use new GDPR form. The old tnc form is only use for iframe
        //const templateData = layoutTemplateStore.templateData;
        //const isIframe = templateData.templateType === Constants.TEMPLATE_TYPE.IFRAME;
        //const isExistingGdprForm = !isIframe 
        //  ? this.checkGDPRForm(layoutTemplateStore)
        //  : false;
        const templateData = layoutTemplateStore.templateData;
        const isIframe = templateData.templateType === Constants.TEMPLATE_TYPE.IFRAME;
        const isExistingGdprForm = !isIframe
            ? templateData.footerContainer.asiaView.filter(f => f.componentName === "MbGDPRModalComponent").length > 0
            : false;

        // Set tncEnabled to cookie
        const tncEnabled = __udata && __udata.auth
            ? (isIframe ? false : (isExistingGdprForm ? false : __udata.tncEnabled)) // if the new GDPR form is not exist then will use old tnc form
            : false;
        StorageHelper.saveBrowsersStorage(BROWSER_KEY.IS_SHOW_ACCEPT_TC, tncEnabled)
        // For Mobile OLD version
        Utils.setShowTCPageST(tncEnabled);

        localStorage.setItem('__udata', window.btoa(unescape(encodeURIComponent(JSON.stringify(__udata)))));
        StorageHelper.saveBrowsersStorage(BROWSER_KEY.SKIN, __udata.skin);
        const modeDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

        if (modeDev) {
            StorageHelper.saveBrowsersStorage(BROWSER_KEY.SKIN, templateName);
        }

        StorageHelper.saveBrowsersStorage(BROWSER_KEY.LOCALE, __udata.locale);
        AccountAction.setUserIP(__udata.userIp);
        const enableMaintenance = _.get(__udata, 'enableMaintenance', false);
        if (__udata.auth) {
            user = {
                'auth': true,
                'loginId': __udata.loginId,
                'userCode': __udata.userCode,
                'freshId': __udata.freshId,
                'email': __udata.email,
                'fullName': __udata.fullName,
                'mode': __udata.mode,
                'currency': __udata.currency,
                'currencyUnit': __udata.currencyUnit,
                'maxBetPreferenceSettingBase': __udata.maxBetPreferenceSettingBase,
                'token': __udata.token,
                'isMultipleBets': __udata.isEnableMultiBet,
                'type': __udata.type,
                'locale': __udata.locale,
                'skin': modeDev ? templateName : __udata.skin,
                'defaultView': __udata.view,
                'isBlockedCasino': __udata.isBlockedCasino,
                'status': __udata.status,
                'productStatus': __udata.productStatus,
                'oddsFormatSetting': __udata.oddsFormatSetting,
                'currentIP': __udata.userIp,
                'country': __udata.country,
                'enableMaintenance': enableMaintenance,
                'tier': VIP_TIER[__udata.tier],
                'kycStatus': __udata.kycStatus,
                'blockedSports': __udata.blockedSports,
                'creditWithdrawalEnabled': __udata.creditWithdrawalEnabled,
                'productUserType': __udata.productUserType,
                'isCrypto': __udata.isCrypto,
                'isBlockedParlay': __udata.isBlockedParlay,
                'showedAnnouncementLoginWith2FA': __udata.showedAnnouncementLoginWith2FA,
                'enableLoginWith2FA': __udata.enableLoginWith2FA,
                'isAccessNewMobileView': __udata.isAccessNewMobileView,
            };
            StorageHelper.saveBrowsersStorage(BROWSER_KEY.AUTH, 'true');
        } else {
            user = {
                'auth': false,
                'loginId': __udata.loginId,
                'userCode': __udata.userCode,
                'freshId': __udata.freshId,
                'email': __udata.email,
                'fullName': __udata.fullName,
                'country': __udata.country,
                'status': __udata.productStatus,
                'productStatus': __udata.productStatus,
                'enableMaintenance': enableMaintenance
            };
            user.sportSuppLS = __udata.sportSuppLS;
            StorageHelper.saveBrowsersStorage(BROWSER_KEY.AUTH, 'false');
        }
        user.liveBlockedSports = __udata.liveBlockedSports;
        user.liveBlockedLeagues = __udata.liveBlockedLeagues;
        user.emailVerification = __udata.kycStatus.includes(KYC_VERIFIED.EMAIL_VERIFIED);
        Utils.setCookieDomain();
        return user;
    }

    static setInfoAfterLogin() {
        const options = {}
        options.ogCache = StorageHelper.getBrowsersStorage(BROWSER_KEY._OG);
        const __prefs = Utils.decodeBase64(StorageHelper.getBrowsersStorage(BROWSER_KEY.__PREFS));
        const __prefsJSON = Utils.convertStringToJSON(__prefs);
        const perfs = localStorage.getItem('perfs') || null;
        const oldPrefs = Utils.convertStringToJSON(perfs);

        options.timeZoneOffset = __prefsJSON[PrefsMap.timeZoneOffset] === null ? moment().utcOffset : __prefsJSON[PrefsMap.timeZoneOffset]
        options.oddsFormat = __prefsJSON[PrefsMap.oddsFormat]
        options.oddsMode = __prefsJSON[PrefsMap.oddsMode]
        options.market = __prefsJSON[PrefsMap.market] === 0 ? Market.Today : Market.All
        options.betTypeGroup = __prefsJSON[PrefsMap.market] === 0 ? BetTypeGroup.HDP_OU : (__prefsJSON[PrefsMap.market] === 1 ? BetTypeGroup.ML_1X2 : BetTypeGroup.TEAM_TOTAL)
        options.order = __prefsJSON[PrefsMap.order]
        options.sportsSorting = __prefsJSON[PrefsMap.sportsSorting] && ("," + __prefsJSON[PrefsMap.sportsSorting] + ",")
        options.enableDefaultStake = __prefsJSON[PrefsMap.enableDefaultStake]
        options.defaultStake = __prefsJSON[PrefsMap.defaultStake]
        options.acceptBetterOdds = __prefsJSON[PrefsMap.acceptBetterOdds]
        options.updateBetslipOdds = __prefsJSON[PrefsMap.updateBetslipOdds]
        options.marketFilter = this.castToMarketFilter(__prefsJSON[PrefsMap.marketFilter]) || 5
        options.liveScoreNotify = __prefsJSON.length >= 12 ? __prefsJSON[PrefsMap.liveScoreNotify] : 0
        options.favouriteEventIds = oldPrefs.favouriteEventIds || []
        options.sound = (typeof (oldPrefs.sound) === "undefined" || true) ? true : false
        options.favourite = oldPrefs.favourite || false
        options.favouriteSportId = oldPrefs.favouriteSportId || 0
        options.timeFilter = oldPrefs.timeFilter || 0
        options.timeZoneId = __prefsJSON[PrefsMap.timeZoneId]
        options.isShowConfirmationModal = __prefsJSON[PrefsMap.acceptBetConfirmationModal]
        localStorage.setItem('perfs', btoa(JSON.stringify(options)))

        if (__prefsJSON[PrefsMap.timeZoneOffset] === null) {
            __prefsJSON[PrefsMap.timeZoneOffset] = moment().utcOffset
            StorageHelper.saveBrowsersStorage(
                BROWSER_KEY.__PREFS,
                btoa(JSON.stringify(__prefsJSON))
            )
        }

        //init data for Classic View
        if (document.URL.indexOf('classic') > -1) {
            let classicOptions = {}
            classicOptions.acceptBetterOdds = __prefsJSON[PrefsMap.acceptBetterOdds]
            classicOptions.oddsFormat = __prefsJSON[PrefsMap.oddsFormat]
            let refreshData = localStorage.getItem('refresh_data') ? JSON.parse(Base64.decode(localStorage.getItem('refresh_data'))) : []
            Object.assign(refreshData, classicOptions);
            localStorage.setItem('refresh_data', Base64.encode(JSON.stringify(refreshData)))
        }
        window.fireEvent(EVENT.UPDATE_SPORTS_STORE);
        return options
    }

    static castToMarketFilter = (marketDisplayType) => {
        switch (marketDisplayType) {
            case "ALL":
                return MarketFilter.All
            case "_1LINE":
                return MarketFilter._1Line
            case "_3LINES":
                return MarketFilter._3Lines
            case "_5LINES":
                return MarketFilter._5Lines
            default:
                return MarketFilter.Error
        }
    }

    static splitDataNoCache(__udata) {
      const _UDATA = JSON.parse(__udata.replace("var __udata=", "").replaceAll(";", ""));
      _UDATA.currentView = '';
      return _UDATA;
    }

    static async accountBalance() {
        return await memberServices.postAccountBalanceAPI().then(response => {
            const result = {
                status: response.status,
                data: response.data
            }
            if (response.data) {
                if (response.data.error) {
                    if (response.data.error === 'MULTIPLE_LOGIN') {
                        Utils.isIniFrame() && window.parent.postMessage({
                            msgCode: 'lostSession',
                            msgData: true
                        }, "*");
                        return this.dataObjectMultipleLogin(response);
                    }
                    
                    if (response.data.error === 403) {
                        StorageHelper.removeToken();
                        StorageHelper.removeBrowsersKey();
                        return result;
                    }

                    if (response.data.msg) {
                        result.data = response.data.msg
                        return result;
                    }
                } else if (!response.data.success) {
                    if (response.data.isValidUserIPRingFencing === false && !Utils.isPA()) {
                        this.gotoBlockPage();
                    }
                }
            }
            return result;
        }).catch(error => {
            if (!error.status) {
                return {
                    status: "net::ERR_NETWORK_IO_SUSPENDED"
                }
            }
            return {
                status: error.response.status
            }
        })
    }

    static dataObjectMultipleLogin(response) {

        return {
            error: _.get(response, 'data.error', ''),
            status: response.status,
            message: i18next.t('errors:MULTIPLE_LOGIN'),
            reload: true
        }
    }

    static async getAcceptTC(isPromoEmail, version) {
        return await memberServices.getAcceptTC(isPromoEmail, version).then(response => {
            return true
        }).catch(error => {
            return false
        })
    }

    static clearDataOnBrowser() {
        if (localStorage.getItem('__udata') != null) {
          const __udata = JSON.parse(window.atob(localStorage.getItem('__udata')));
          document.body.classList.remove(__udata.type);
          document.documentElement.classList.remove(__udata.type);
          __udata.auth = false;
          localStorage.setItem('__udata', window.btoa(JSON.stringify(__udata)));
        }
       
        sessionStorage.removeItem('perfs');
        localStorage.removeItem('perfs');
        localStorage.removeItem('defaultView');
        localStorage.removeItem('_needToChangePW');
        localStorage.removeItem(LOCAL_STORAGE_KEY.V_HUCODE); 
        window.fireEvent(EVENT.USER_LOG_OUT);
    }

    static setUserIP(userIp) {
        let localUserIp = window.atob(localStorage.getItem('rip')) || null
        if (typeof localUserIp === 'undefined' || localUserIp === null || localUserIp !== userIp) {
            localStorage.setItem('rip', window.btoa(userIp))
        }
    }

    static openNewBetslipMobileNotify() {
        AlertComponentAction.openAlertCallBack(
            i18next.t("NEW_MOBILE_BETSLIP_NOTIFY"),
            AccountAction.acceptNewBetslipMobileNotify,
            "alert_bet_confirmation new_bet_modal",
            i18next.t("New Bet Slip on Mobile")
        );
    }

    static openLiveParlaysNotify() {
        AlertComponentAction.openAlertCallBack(
            i18next.t("LIVE_PARLAYS_NOTIFY_BODY"),
            AccountAction.acceptLiveParlaysNotify,
            "alert_bet_confirmation new_bet_modal",
            i18next.t("LIVE_PARLAYS_NOTIFY_TITLE")
        );
    }

    static openAnnouncementLoginWith2FA() {
        AlertComponentAction.openNewAdvanceConfirm(
            i18next.t(Constants.LOGIN_2FA.TRANSLATIONS.TITLE_SETTING_LOGIN_OTP_CONFIRM),
            i18next.t(Constants.LOGIN_2FA.TRANSLATIONS.BODY_SETTING_LOGIN_OTP_CONFIRM),
            () => AccountAction.disableLogin2FAAnnouncement(false),
            i18next.t(Constants.LOGIN_2FA.TRANSLATIONS.SUBMIT_ENABLE_2FA_LOGIN),
            () => AccountAction.disableLogin2FAAnnouncement(true),
            i18next.t(Constants.LOGIN_2FA.TRANSLATIONS.NOT_NOW),
            "alert_bet_confirmation new_bet_modal",
            true
        );
    }

    static openSessionExpiredPopup() {
        AlertComponentAction.openAlertCallBack(
            i18next.t("errors:SESSION_REAUTH_REQUIRED"),
            () => localStorage.removeItem(LOCAL_STORAGE_KEY.SESSION_EXPIRED),
            "alert_bet_confirmation new_bet_modal",
            i18next.t("errors:SESSION_EXPIRED")
        );
    }

    static displayFeaturePopup() {
        const featurePopupList = Utils.getPopupList();

        if(!featurePopupList.length) return;
        
        switch(featurePopupList[0]) {
          case Constants.POPUP_LIST.SESSION_EXPIRED:
            AccountAction.openSessionExpiredPopup();
            break;
          case Constants.POPUP_LIST.NEW_BETSLIP_MOBILE:
           AccountAction.openNewBetslipMobileNotify();
            break;
          case Constants.POPUP_LIST.LIVE_PARLAYS:
            AccountAction.openLiveParlaysNotify()
            break;
          case Constants.POPUP_LIST.LOGIN_2FA_ENABLE:
            AccountAction.openAnnouncementLoginWith2FA()
            break;
          default:
            return;
        }
    }

    static async acceptNewBetslipMobileNotify() {
        try {
            const response = await memberServices.acceptNewBetslipMobileNotify();
            if(!response.data) {
                AccountAction.openNewBetslipMobileNotify();
                return;
            }
            localStorage.setItem('__udata', window.btoa(JSON.stringify({...Utils.getUdata(), newBetslipPopupEnabled: false})))
            AccountAction.displayFeaturePopup();
        }
        catch (err) {
            console.log(err)
        }
    }

    static async forfeitBonus(txnNo) {
        try {
            const response = await memberServices.forfeitBonus(txnNo);
            return response.data;
          } catch (err) {
            console.log(err);
            return false;
          }
    }

    static async forfeitSubscriptionBonus(promotionId) {
        try {
            const response = await memberServices.forfeitSubscriptionBonus(promotionId);
            return response.data;
          } catch (err) {
            console.log(err);
            return false;
          }
    }

    static async acceptLiveParlaysNotify() {
        try {
            const response = await memberServices.acceptLiveParlaysNotify();
            if(!response.data) {
                AccountAction.openLiveParlaysNotify();
                return;
            }
            localStorage.setItem('__udata', window.btoa(JSON.stringify({...Utils.getUdata(), liveParlaysPopupEnabled: false})))
            AccountAction.displayFeaturePopup();
        }
        catch (err) {
            console.log(err)
        }
    }

    static async disableLogin2FAAnnouncement(isNotNow) {
        if (isNotNow) {
            // Just disable the announcement
            const response = await memberServices.toggleLoginOTP({
                showedAnnouncementLoginWith2FA: true
            });
            return response.data;
        } else {
            // Disable the announcement and update user to use 2FA at login
            // Send OTP
            const response = await memberServices.toggleLoginOTP();
            // Open input otp modal
            if (response.data === Constants.LOGIN_2FA.STATUS.OTP_REQUIRED) {
                AlertComponentAction.closeAlert()
                window.fireEvent(EVENT.USER_ENABLE_2FA_LOGIN);
            }
        }
    }

    static notifyLiveScore() {
        let auth = this.isAuth();
        let perfs = null
        try {
            perfs = JSON.parse(window.atob(localStorage.getItem('perfs')))
        } finally {
            if (typeof perfs === 'undefined' || perfs === null) {
                return {
                    showPopup: false,
                    message: ''
                }
            }
        }

        let liveScoreNotify = perfs.hasOwnProperty('liveScoreNotify') ? perfs.liveScoreNotify : null
        if (auth && (typeof (liveScoreNotify) === "undefined" || liveScoreNotify === null)) {
            this.setInfoAfterLogin()
            liveScoreNotify = perfs.liveScoreNotify
        }
        let isRemindLater = perfs.hasOwnProperty('isRemindLater') ? perfs.isRemindLater : 0
        if (liveScoreNotify < 0 && auth && !isRemindLater) {
            return {
                showPopup: true,
                message: 'New feature Live Score Announcement is now avaiable.<br>Do you want to enable this feature for your conveniences?'
            }
        }
        return {
            showPopup: false,
            message: ''
        }
    }

    static updateNotifyLiveScore(accept) {
        let perfs = null
        try {
            perfs = JSON.parse(window.atob(localStorage.getItem('perfs')))
        } finally {
            if (typeof perfs === 'undefined' || perfs === null) {
                return
            }
        }
        if (accept === -1) {
            perfs.isRemindLater = 1
            localStorage.setItem('perfs', window.btoa(JSON.stringify(perfs)))
            window.location.href = window.location.href
        }
        perfs.liveScoreNotify = accept
    }

    static redirect() {
        if (_.get(window, 'env.isBrandEnableLogoutOnArcadia')) {
            const pathname = `/m/${Utils.getCurrentLang()}/asian`;
            window.location.href = this.getArcadiaURL(window.env.futureViewURL || window.env.fvURL || window.location.href, pathname);
        } else {
            window.location.reload();
        }
    }
    static handleMultipleLogin() {
        AccountAction.logout()
    }

    static reloadAccountBalance(AccountStore) {
        const needToChangePW = localStorage.getItem("_needToChangePW"); 
        const { keepAliveNewEndpointEnabled, enableNewInboxMessageContent } = window.env || {};
        if (!needToChangePW) {
            return AccountAction.accountBalance().then(response => {
                if (response.status === 200) {
                    if (response.error) {
                        if (response.error === 'MULTIPLE_LOGIN') {
                            AccountStore.resetUser();
                            StorageHelper.removeToken();
                            AlertComponentAction.openAlert(response.message, '', false, () => AccountAction.logout());
                            return;
                        }
                        AlertComponentAction.openAlert(response.message);
                        this.clearDataOnBrowser();
                    }
                    // Hanle for Self Exclusion 
                    if (!response.data.success && _.get(AccountStore, 'user.auth', false)) {
                        response.data.isSessionExpired && localStorage.setItem(LOCAL_STORAGE_KEY.SESSION_EXPIRED, true);
                        AccountAction.logout().finally(() => {
                        window.location.href = `/m/${Utils.getCurrentLang()}/asian`;
                      });
                      return;
                    }
                    if (!response.data.success && response.data.isExceedSessionLimit) {
                        return response.data;
                    }
                    if (response.message) {
                        AccountStore.updateStatus(response)
                        return
                    }

                    if (!keepAliveNewEndpointEnabled) {
                        AccountAction.updateTokenStorage(_.get(response, "data.tokens", ""));
                    }

                    const isAuth = !_.isNil(response.data.loginId);
                    const totalMessage = _.get(response, 'data.totalMessage', 0);
                    const __prefs = _.isEmpty(localStorage.getItem('perfs')) ? '' : Utils.decodeBase64(localStorage.getItem('perfs'));
                    const __prefsJSON = _.isEmpty(__prefs) ? {} : Utils.convertStringToJSON(__prefs);
                    AccountStore.updateUser({
                        'auth': isAuth,
                        'loginId': response.data.loginId,
                        'currency': response.data.currency,
                        'betCredit': Utils.formatBalance(response.data.betCredit),
                        'outstanding': Utils.formatBalance(response.data.outstanding),
                        'message': response.data.totalMessage,
                        'sumAnnouncement': response.data.sumAnnouncement,
                        'isRefresh': true,
                        'tier': VIP_TIER[response.data.currentTierId],
                        'hasLoginMessage': response.data.hasLoginMessage,
                        'betTypeGroup': __prefsJSON.betTypeGroup ? __prefsJSON.betTypeGroup : BetTypeGroup.HDP_OU,
                        ...(!_.isUndefined(response.data.cashBonus) ? {
                            cashBonus: Utils.formatBalance(response.data.cashBonus)
                        } : {}),
                        'totalBalance': Utils.parseBalance(response.data.cashBonus) + Utils.parseBalance(response.data.betCredit)
                    })
                    let __udata = Utils.getUdata() || null
                    if (__udata.currentTierId !== response.data.currentTierId) {
                        const newUdata = { ...__udata, currentTierId: response.data.currentTierId }
                        localStorage.setItem('__udata', window.btoa(JSON.stringify(newUdata)))
                    }
                    window.fireEvent(EVENT.REFRESH)
                    if (_.isNil(response.data.loginId)) {
                        AccountAction.clearDataOnBrowser();
                    }
                    const isCreditUser = AccountStore.isCreditUser;
                    const displayMessPopUp = StorageHelper.getBrowsersStorage(BROWSER_KEY.DISPLAY_MESS_POPUP) || false;
                    if (isAuth
                      && !displayMessPopUp
                      && (isCreditUser || (!isCreditUser && enableNewInboxMessageContent))) {
                      if (totalMessage > 0) {
                        AccountStore.updateIsOpenMessagePopup(true);
                      }
                        StorageHelper.saveBrowsersStorage(BROWSER_KEY.DISPLAY_MESS_POPUP, true);
                    }
                    return response.data;
                  }
            });
        }
        else return Promise.resolve({});
    }

    static async getDataKeepAlive() {
        try {
            const response = await memberServices.getKeepAliveSession();
            AccountAction.updateTokenStorage(_.get(response, "data.tokens", ""));
            StorageHelper.saveVHUCode(_.get(response, `headers.${LOCAL_STORAGE_KEY.V_HUCODE}`, ""))
        } catch (error) {
            console.error(error);
        }
    }

    static isAuth() {
        if (!_.isNil(StorageHelper.getBrowsersStorage(BROWSER_KEY.AUTH))) {
            return StorageHelper.getBrowsersStorage(BROWSER_KEY.AUTH) === 'true';
        }
        return false;
    }

  static clearSession() {
    // remove all the cookies which are added by client
    StorageHelper.clearSessionBrowser();
  }

	static isChangePasswordPage (){
    return window.location.href.includes("change-password");
  }

  static updateDefaultView(view){
    memberServices.updateDefaultView(view).then(res => {
        if (res){
            // CommonUtil.saveUserData('view', view);
        }
    });
  }

   /**
     * load capcha image
     * 
     * @param {*} moduleName 
     */
    static async loadCaptchaImage(moduleName) {
      return await memberServices.getCaptchaImage(moduleName).then(response => {
          if (response.data) {
              return response.data
          }
          return null
      }).catch(error => {
          console.log("Load Captchar error: ", error)
          return null
      })
    }

    static checkTrustCodeExisted(loginId) {
      const trustCodeStorage = localStorage.getItem("trustCode");
      const trustCodes = JSON.parse(trustCodeStorage);
      return this.checkLoginTrustCodeExisted(loginId, trustCodes);
    }

    static addTrustCodeToLocalStorage(loginId, trustCode, trustCodeObj) {
      if (trustCode) {
        trustCodeObj[loginId] = trustCode
        localStorage.setItem("trustCode",  JSON.stringify(trustCodeObj))
      }
    }

    static checkLoginTrustCodeExisted(loginId, trustCodeObj) {
      return trustCodeObj && !_.isNil(trustCodeObj[loginId]);
    }

    static deleteLoginTrustCode(loginId) {
      const trustCodeStore = localStorage.getItem("trustCode");
      if(trustCodeStore) {
        let trustCodeObj = JSON.parse(trustCodeStore);
        if (this.checkLoginTrustCodeExisted(loginId, trustCodeObj)) {
          delete trustCodeObj[loginId];
          localStorage.setItem("trustCode",  JSON.stringify(trustCodeObj))
        }
      }
    }

    static async sendActiveEmail(params) {
        try {
            const res = await memberServices.getActiveLink(params)
            return res.data
        } catch (error) { }
    }
    
    static async getOtpType(params) {
        try {
            const res = await memberServices.getOtpType(params)
            return res.data
        } catch (error) { }
    }
}



// WEBPACK FOOTER //
// ./src/app/actions/AccountAction.js